import React from "react";
import { Link } from "react-router-dom";
import useCart from "../../../hooks/useCart";
import { hasImage } from "../../Products/components/ProductItem";
import { formatCurrency } from "../../../util/formatters";

// .toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
const SideCartItem = (props) => {
  const { dispatch } = useCart();
  const removeCartItem = () => {
    dispatch({
      type: "DELETE",
      obj: props.obj,
    });
  };
  return (
    <div className="mini-cart-item clearfix">
      <div className="mini-cart-img go-top">
        <Link
          to={`/produto/${props.obj.id}`}
          title={props.obj.product_name ? `Ver produto — ${props.obj.product_name}` : "Ver produto"}
        >
          <img
            src={hasImage(props.obj.image)}
            alt={props.obj.product_name ? `${props.obj.product_name} - ${props.obj.product_id}` : "Imagem do produto no carrinho"}
            style={{ height: "80px" }}
            loading="lazy"
          />
        </Link>
        <span onClick={removeCartItem} className="mini-cart-item-delete">
          <i className="icon-cancel" />
        </span>
      </div>
      <div className="mini-cart-info go-top">
        <h6>
          <Link
            to={`/produto/${props.obj.id}`}
            title={props.obj.product_name ? `Ver produto — ${props.obj.product_name}` : "Ver produto"}
          >
            {props.obj.product_name}
          </Link>
        </h6>
        <span className="mini-cart-quantity">
          {props.obj.quantity} x {formatCurrency(props.obj.price)}
        </span>
      </div>
    </div>
  );
};
export default SideCartItem;
